export default "/wp-content/themes/allen-carr/public/dist/images/icon_withdrawal.png";